export default "__VITE_ASSET__D_4zhi3G__"